<script setup lang="ts">
import {toTypedSchema} from '@vee-validate/zod'
import {useField} from 'vee-validate'
import {ZodSchema} from 'zod'

const props = defineProps<{
  name: string
  label: string
  placeholder?: string
  validation?: ZodSchema
  required?: boolean
}>()

const {handleBlur, value, errorMessage, setValue} = useField<string>(
  props.name,
  props.validation ? toTypedSchema(props.validation) : undefined
)
</script>

<template>
  <FormTextarea
    @update:model-value="setValue($event, false)"
    :model-value="value"
    @blur="handleBlur"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :error="errorMessage"
    :required="required"
  />
</template>
